import React, { useEffect, useState } from "react";
import { Container, Row, Col, ListGroup } from "react-bootstrap";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import Loader from "../../loader/Loader";

const PrivacyPolicy = () => {
  const [loading, setloading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setloading(false);
    }, 500);
  }, []);

  window.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "nedui962",
  };
  // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/nedui962'
  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === "function") {
      ic("reattach_activator");
      ic("update", w.intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function () {
        var s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://widget.intercom.io/widget/nedui962";
        var x = d.getElementsByTagName("script")[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === "complete") {
        l();
      } else if (w.attachEvent) {
        w.attachEvent("onload", l);
      } else {
        w.addEventListener("load", l, false);
      }
    }
  })();
  return (
    <>
      <Header />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="hero">
            <Container>
              <Row className="justify-content-center">
                <Col xl="17">
                  <h1 className="text-center mb-0">Privacy policy</h1>
                </Col>
              </Row>
            </Container>
          </div>
          <Container>
            <Row className="justify-content-center mb-11 mb-md-12 mb-xxl-13 mb-xxxl-14">
              <Col xl="18" xxl="16" xxxl="13">
                <p className="mb-1">Effective Date: 12th May 2025</p>
                <p className="mb-1">Company Name: Elderly Life Ltd</p>
                <p className="mb-1">Company Number: 13256285</p>
                <p className="mb-7">
                  Registered Address: Unit H, Gateway 1000 Whittle Way,
                  Stevenage, England, SG1 2FP
                </p>

                <h2 className="h5">Introduction</h2>
                <p>
                  Elderly Life Ltd ("we", "our", or "us") is committed to
                  protecting your privacy. This Privacy Policy explains how we
                  collect, use, and protect your personal data when you use our
                  website and services.
                </p>
                <p>
                  We act as a data controller under the UK General Data
                  Protection Regulation (UK GDPR) and the Data Protection Act
                  2018.
                </p>

                <h2 className="h5">What Information We Collect</h2>
                <h3 className="h6">Personal Information You Provide:</h3>
                <ListGroup className="br-none mb-7">
                  <ListGroup.Item>
                    Name, email address, and contact details{" "}
                  </ListGroup.Item>
                  <ListGroup.Item>Account login credentials </ListGroup.Item>
                  <ListGroup.Item>
                    Payment details (processed securely via Stripe – we do not
                    store your card details){" "}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Information you submit in support chats or messages (via
                    Intercom){" "}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Optional information you enter about outgoings, reminders,
                    accounts, warranties, etc.{" "}
                  </ListGroup.Item>
                </ListGroup>

                <h3 className="h6">Automatically Collected Data:</h3>
                <ListGroup className="br-none mb-7">
                  <ListGroup.Item>
                    IP address, device type, browser, pages visited (via Google
                    Analytics or similar tools){" "}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Interaction data with our website or support chat{" "}
                  </ListGroup.Item>
                </ListGroup>

                <h3 className="h6">Third-Party Integrations:</h3>
                <p>
                  We may receive limited data via integrations with services
                  like:
                </p>
                <ListGroup className="br-none mb-7">
                  <ListGroup.Item>
                    <span className="fw-bold">Stripe</span> – payments
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <span className="fw-bold">Xero</span> – accounting
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <span className="fw-bold">Intercom</span> – customer support{" "}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <span className="fw-bold">Civo</span> – secure cloud data
                    storage
                  </ListGroup.Item>
                </ListGroup>

                <h2 className="h5">How We Use Your Information</h2>
                <p>We use your data to: </p>
                <ListGroup className="br-none mb-7">
                  <ListGroup.Item>
                    Provide, maintain, and improve our services{" "}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Process subscriptions and payments{" "}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Respond to support requests and messages{" "}
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Send essential communications (e.g. billing updates,
                    reminders){" "}
                  </ListGroup.Item>
                  <ListGroup.Item>Comply with legal obligations</ListGroup.Item>
                  <ListGroup.Item>
                    Conduct limited analytics to improve the platform{" "}
                  </ListGroup.Item>
                </ListGroup>

                <h2 className="h5">Legal Bases for Processing</h2>
                <p>We process your data under the following legal bases: </p>
                <ListGroup className="br-none mb-7">
                  <ListGroup.Item>
                    <span className="fw-bold">Performance of a contract</span> –
                    e.g. to deliver your subscription
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <span className="fw-bold">Consent</span> – e.g. for cookies
                    or optional communications
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <span className="fw-bold">Legitimate interests</span> – e.g.
                    improving the service
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <span className="fw-bold">Legal obligation</span> – e.g. for
                    financial record keeping
                  </ListGroup.Item>
                </ListGroup>

                <h2 className="h5">Data Retention</h2>
                <ListGroup className="br-none mb-7">
                  <ListGroup.Item>
                    We retain your data for as long as your account is active.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    After cancellation, we retain your data for up to one year,
                    unless you request deletion sooner.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    You can email support@elderlylife.com to request deletion at
                    any time.
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Some data may be kept longer if required by law (e.g. tax
                    rules).
                  </ListGroup.Item>
                </ListGroup>

                <h2 className="h5">How We Share Your Data</h2>
                <p>
                  We only share data with trusted third parties who support our
                  service, including:{" "}
                </p>
                <ListGroup className="br-none">
                  <ListGroup.Item>
                    <span className="fw-bold">Stripe</span> (payment processing)
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <span className="fw-bold">Xero </span>(accounting and
                    invoicing)
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <span className="fw-bold">Intercom </span>(support
                    messaging)
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <span className="fw-bold">Civo</span> (secure cloud data
                    hosting)
                  </ListGroup.Item>
                  <ListGroup.Item>
                    IT and infrastructure providers necessary for service
                    delivery
                  </ListGroup.Item>
                </ListGroup>
                <p className="mb-7">
                  All partners are subject to UK GDPR-compliant agreements. We
                  never sell or rent your personal data.
                </p>

                <h2 className="h5">International Data Transfers</h2>
                <p className="mb-7">
                  Some of our third-party services may process data outside the
                  UK (e.g. Stripe, Intercom). In such cases, we ensure
                  appropriate safeguards are in place, such as UK-approved
                  Standard Contractual Clauses.
                </p>

                <h2 className="h5">Your Rights</h2>
                <p>Under the UK GDPR, you have the right to:</p>
                <ListGroup className="br-none">
                  <ListGroup.Item>Access your personal data</ListGroup.Item>
                  <ListGroup.Item>
                    Correct inaccurate or outdated data
                  </ListGroup.Item>
                  <ListGroup.Item>Request deletion of your data</ListGroup.Item>
                  <ListGroup.Item>
                    Object to or restrict processing
                  </ListGroup.Item>
                  <ListGroup.Item>Request data portability</ListGroup.Item>
                  <ListGroup.Item>
                    Withdraw consent at any time (where applicable)
                  </ListGroup.Item>
                </ListGroup>
                <p className="mb-7">
                  To exercise any of these rights, email
                  support@elderlylife.com. We aim to respond within one month.
                </p>

                <h2 className="h5">Data Security</h2>
                <p>
                  We implement strong technical and organisational security
                  measures to protect your personal data.
                </p>
                <p className="mb-7">
                  This includes encryption, access controls, secure hosting (via
                  Civo), and regular monitoring.{" "}
                </p>

                <h2 className="h5">Cookies</h2>
                <p>We use cookies to: </p>
                <ListGroup className="br-none">
                  <ListGroup.Item>Enable essential features</ListGroup.Item>
                  <ListGroup.Item>Understand website usage</ListGroup.Item>
                  <ListGroup.Item>Improve your experience</ListGroup.Item>
                </ListGroup>
                <p className="mb-7">
                  You can adjust your preferences via our cookie banner or
                  browser settings. Please read our{" "}
                  <a href="Cookie-policy">Cookies Policy</a> or full details.
                </p>

                <h2 className="h5">Changes to This Policy</h2>
                <p>We may update this Privacy Policy from time to time. </p>
                <p>
                  We will post any changes on our website and notify you if
                  material changes are made.
                </p>
                <p className="mb-7">
                  We encourage you to review this policy regularly.
                </p>

                <h2 className="h5">Contact Us</h2>
                <p>
                  if you have questions or concerns about your data or this
                  Privacy Policy, contact us at: Elderly Life Ltd{" "}
                  <a href="mailto:support@elderlylife.com">
                    support@elderlylife.com
                  </a>
                </p>
                <p>
                  Unit H, Gateway 1000 Whittle Way, Stevenage, England, SG1 2FP
                  If you're not satisfied with our response, you can contact the
                  Information Commissioner's Office (ICO):{" "}
                  <a href="https://ico.org.uk/">www.ico.org.uk</a>
                </p>
              </Col>
            </Row>
          </Container>
          <Footer />
        </>
      )}
    </>
  );
};

export default PrivacyPolicy;
